<template>
  <div>
    <cpo-performance-header :item="highlight" />
    <div class="container">
      <h1 class="nav-title">{{ $t("performance.title") }}</h1>
      <cpo-performance-list :items="performances" :mode="1" />
      <h1 class="nav-title">{{ $t("nav.news") }}</h1>
      <cpo-news-list :items="news" />
    </div>
  </div>
</template>

<script>
import CpoPerformanceHeader from "@/components/CpoPerformanceHeader.vue";
import CpoPerformanceList from "@/components/CpoPerformanceList.vue";
import CpoNewsList from "@/components/CpoNewsList.vue";
export default {
  components: { CpoPerformanceHeader, CpoPerformanceList, CpoNewsList },
  data() {
    return {
      highlight: null,
      performances: [],
      news: []
    };
  },
  created() {
    this.$axios.post("/performance/getHighlight").then((data) => {
      this.highlight = data;
    });
    this.$axios
      .post("/performance/list", {
        pageSize: 6,
        filter: [],
        sort: [{ field: "date", asc: false }]
      })
      .then((data) => {
        this.performances = data;
      });
    this.$axios.post("/news/list", { filter: [], sort: [{ field: "date", asc: false }], pageSize: 6 }).then((data) => {
      this.news = data;
    });
  }
};
</script>
<style lang="scss"></style>
